import { useLocation } from 'react-router-dom';
import qs from 'qs';

const useQueryParams = <T extends object>() => {
    const location = useLocation();
    return location.search.length > 0
        ? (qs.parse(location.search.split('?')[1]) as T)
        : ({} as Partial<T>);
};

export { useQueryParams };
